
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import Utils from "@/assets/js/Utils";
import dialogCom from "@/components/ModelCom.vue";
import delCom from "@/components/DelDataCom.vue";
import deviceList from "../ShareComponents/DeviceChooseCom.vue";
import softList from "../ShareComponents/SoftChooseCom.vue";
import routerList from "../ShareComponents/RouterChooseCom.vue";
import jgList from "../ShareComponents/ChooseJGCom.vue";
// import loopList from "../ShareComponents/LoopChooseCom.vue";
import gatewayList from "../ShareComponents/GatewayChooseCom.vue";
import { StoreTypes } from "@/assets/js/Types";
import hardList from "../ShareComponents/HardChooseCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import logCom from "../ShareComponents/TaskLogCom.vue";
import AIAskCom from "../ShareComponents/AIAskCom.vue";
export default Vue.extend({
  components: {
    action,
    pageCom,
    dialogCom,
    delCom,
    deviceList,
    routerList,
    logCom,
    hardList,
    gatewayList,
    AIAskCom,
    jgList,
  },
  data() {
    return {
      props: {
        label: "groupName",
        children: "children",
      },
      groups: [] as any,
      image: require("@/assets/img/icon/deepseek.png"),

      deviceTypes: this.$store.state.device[StoreTypes.XC_DEVICE_TYPE].filter(
        (x: any) => x.categorySid == 0 || x.categorySid == 1 || x.categorySid == 4
      ),
      devTypes: [] as any[],
      loopSavedItem: [] as any,
      loopCSavedItem: [] as any,
      devSavedItem: [] as any[],
      routerSavedItem: [] as any[],
      softSavedItem: [] as any[],
      devCSavedItem: [] as any[],
      routerCSavedItem: [] as any[],
      softCSavedItem: [] as any[],
      hardSavedItem: [] as any[],
      hardCSavedItem: [] as any[],
      getwaySavedItem: [] as any[],
      getwayCSavedItem: [] as any[],
      policys: [] as any[],
      activeName: "0",
      delUrl: Urls.DelTask,
      currentSid: "",
      items: [] as any[],
      total: 0,
      pageSize: 6,
      currentPage: 1,
      searchStr: null as any,
      dialogTitle: {
        title: "新增项目",
      },
      projectForm: {
        sid: null,
        isTimmer: 0,
        timmerType: 0,
        policyTimers: [],
        PolicyLoops: [],
      } as any,
      current: null as any,
      projects: [] as any[],
      step: 0,
      policySEDate: [] as any[],
      listPolicy: [] as any[],
      jgSavedItem: [] as any[],
      jgCSavedItem: [] as any[],
    };
  },
  async mounted() {
    this.devTypes = this.deviceTypes.filter((x: any) => x.categorySid == 0);
    await this.select();
  },
  methods: {
    async getGroups() {
      console.log(this.current);
      let type = 0;
      // if (this.current.deviceTypeSid == "10") {
      //   type = 3;
      // } else if (
      //   this.current.deviceTypeSid == "4" ||
      //   this.current.deviceTypeSid == "6" ||
      //   this.current.deviceTypeSid == "9"
      // ) {
      //   type = 2;
      // } else if (
      //   this.current.deviceTypeSid == "1" ||
      //   this.current.deviceTypeSid == "2" ||
      //   this.current.deviceTypeSid == "7" ||
      //   this.current.deviceTypeSid == "8" ||
      //   this.current.deviceTypeSid == "11" ||
      //   this.current.deviceTypeSid == "12"
      // ) {
      //   type = 0;
      // } else {
      //   type = -1;
      // }
      if (this.projectForm.target == 0) {
        type = 0;
      } else if (this.projectForm.target == 2) {
        type = 1;
      } else if (this.projectForm.target == 3) {
        type = 3;
      }
      const ret: any = await HttpUtil.XCHttpPost(Urls.GetSoftGroups, type, true, false);
      this.groups = [
        {
          groupName: "根目录",
          sid: null,
          children: ret,
        },
      ];
      const tree: any = this.$refs.tree;
      if (this.softSavedItem && this.softSavedItem.length > 0) {
        tree.setCheckedKeys(this.softSavedItem);
        console.log(tree, "testetet");
      } else {
        this.softSavedItem = [];
        tree.setCheckedKeys([]);
      }
    },
    async aiDevice(obj: any) {
      const reslut = await DeviceRequestBill.GetTaskDetail(obj.sid);
      console.log(reslut);
      const current: any = {
        电压: obj.voltage + "v",
        电流: obj.current + "A",
        功率因素: obj.powerFactory,
        亮度: obj.light,
        在线状态: obj.online == 0 ? "离线" : "在线",
        设备序号: obj.ctrlAddr,
        功率: obj.power,
        信号强度: obj.signal + "dBm",
      };
      const projectInfo = this.$store.state.project[StoreTypes.XC_PROJECT_CURRENT];
      let data: any = [];
      if (!reslut.policies.length) {
        throw "当前为空策略";
      } else {
        for (let i = 0; i < reslut.policies.length; i++) {
          const sid = reslut.policies[i].policySid;
          const res = await DeviceRequestBill.GetPolicyDetail(sid);
          console.log(res, "tt");
        }
      }
      const by =
        obj.target == 0
          ? "路灯的调光亮灯策略"
          : obj.target == 2
          ? "供电回路的开关状态"
          : "路上景观灯具的亮灯开关策略";
      const msg = `这是一个智慧路灯项目上用的节能策略，
      是用于${by},该策略有${
        reslut.policies.length
      }条具体的策略，以优先级为执行前后顺序的依据，
      冲突时优先级高的优先执行，
      具体的策略分为两种策略方案，定时策略以及日出日落策略，
      定时策略是指定时定点执行相应的指令，日出日落策略是指在日出或
      日落这样的时间节点执行相应的指令。日出日落策略还可以设置一个指令执行的偏移量，偏移量以分钟为单位。
      具体策略如下：${3}。
      这个项目位于经度${1}，纬度${1},当前时间为${1}，
      请分析一下个节能策略的合理性。`;
      const dialog: any = this.$refs.aiDialog;
      // dialog.open(msg);
    },
    down() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      HttpUtil.XCHttpPost(Urls.ExecPolicyTask, this.current.sid, true, false);
    },
    downPolicy() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      HttpUtil.XCHttpPost(Urls.ExecPolicyTaskFix, this.current.sid, true, false);
    },
    logClick(sid: string) {
      this.currentSid = sid;
      const log: any = this.$refs.logDialog;
      log.show();
    },
    logOpend() {
      const log: any = this.$refs.logList;
      log.getList();
    },
    closeLogDialog() {
      const log: any = this.$refs.logDialog;
      log.hiden();
    },
    jgSelectChange(val: any[]) {
      if (val.length == 0 && this.jgSavedItem.length > 1) {
        return;
      }
      this.jgCSavedItem = val;
      const di: any[] = [];
      this.jgCSavedItem.forEach((x) => {
        di.push(x.sid);
      });
      this.jgSavedItem = di;
    },
    devSelectChange(val: any[]) {
      if (val.length == 0 && this.devSavedItem.length > 1) {
        return;
      }
      this.devCSavedItem = val;
      const di: any[] = [];
      this.devCSavedItem.forEach((x) => {
        di.push(x.sid);
      });
      this.devSavedItem = di;
    },
    async deviceTypeChange() {
      if (this.listPolicy.length == 0) {
        this.listPolicy = (await DeviceRequestBill.GetPolicys(null, 1, 10000)).data;
      }
      if (this.projectForm.target == 0) {
        this.policys = this.listPolicy.filter(
          (x: any) => x.deviceTypeSid == this.projectForm.deviceTypeSid
        );
      } else if (this.projectForm.target == 2) {
        this.policys = this.listPolicy.filter((x: any) => x.isLightPolicy == 2);
      } else if (this.projectForm.target == 3) {
        this.policys = this.listPolicy.filter((x: any) => x.isLightPolicy == 3);
      }
    },
    softSelectChange(val: any[]) {
      // this.softCSavedItem = val;
      // this.softSavedItem = [];
      // this.softCSavedItem.forEach((x) => {
      //   this.softSavedItem.push(x.sid);

      //   // if(!this.softSavedItem.find(y=>y==x.sid)){
      //   //     this.softSavedItem.push(x.sid);
      //   // }
      // });
      const tree: any = this.$refs.tree;
      const list: any[] = tree.getCheckedNodes();
      this.softCSavedItem = list;
      this.softSavedItem = [];
      this.softCSavedItem.forEach((ele: any) => {
        if (ele.sid) {
          this.softSavedItem.push(ele.sid);
        }
      });
    },
    hardSelectChange(val: any[]) {
      this.hardCSavedItem = val;
      this.hardSavedItem = [];
      this.hardCSavedItem.forEach((x) => {
        this.hardSavedItem.push(x.sid);
      });
    },
    gatewaySelectChange(val: any[]) {
      this.getwayCSavedItem = val;
      this.getwaySavedItem = [];
      this.getwayCSavedItem.forEach((x) => {
        // if(!this.getwaySavedItem.find(y=>y==x.sid)){
        //     this.getwaySavedItem.push(x.sid);
        // }

        this.getwaySavedItem.push(x.sid);
      });
    },
    routerSelectChange(val: any[]) {
      this.routerCSavedItem = val;
      this.routerSavedItem = [];
      this.routerCSavedItem.forEach((x) => {
        this.routerSavedItem.push(x.sid);
      });
    },
    loopSelectChange(val: any[]) {
      this.loopCSavedItem = val;
      this.loopSavedItem = [];
      this.loopCSavedItem.forEach((x: any) => {
        this.loopSavedItem.push(x.sid);
      });
    },
    async targetChange(val?: number) {
      if (this.listPolicy.length == 0) {
        this.listPolicy = (await DeviceRequestBill.GetPolicys(null, 1, 10000)).data;
      }
      const value = val == 0 ? 0 : val == 2 ? 1 : 4;
      console.log(this.deviceTypes);
      this.devTypes = this.deviceTypes.filter((x: any) => x.categorySid == value);
      // if(this.devTypes.length!=0){
      //   this.projectForm.deviceTypeSid=this.devTypes[0].sid;
      // }
      await this.deviceTypeChange();
      // this.policys=this.listPolicy.filter((x:any)=>x.isLightPolicy==val);
      // val = val || this.projectForm.target;
      // val = (val || 0) * 1;
      // this.policys = this.listPolicy.filter((x) =>
      //   x.isLightPolicy == val &&
      //   (x.isPlatformPolicy == this.projectForm.runInPlatform) == true
      //     ? 1
      //     : 0
      // );
    },
    handleClick() {
      console.log(this.activeName, "tetstett");
      let list: any = null;
      if (this.activeName == "0") {
        list = this.$refs.devList;
        list.getList(true);
      }
      if (this.activeName == "1") {
        list = this.$refs.routerList;
        list.getList(true);
      }
      if (this.activeName == "2") {
        // list = this.$refs.softList;
        // list.getList(true);
        this.getGroups();
      }
      if (this.activeName == "3") {
        list = this.$refs.hardList;
        list.getList(true);
      }
      if (this.activeName == "4") {
        list = this.$refs.gatewayList;
        list.getList(true);
      }
      if (this.activeName == "5") {
        list = this.$refs.loopList;
        list.getList(true);
      }
      if (this.activeName == "6") {
        list = this.$refs.jgList;
        list.getList(true);
      }
    },
    next(page: number) {
      this.step = page;
      if (this.projectForm.target == 2) {
        this.activeName = "4";
      } else if (this.projectForm.target == 3) {
        this.activeName = "6";
      } else {
        this.activeName = "0";
      }
      this.handleClick();
    },
    addTimmer() {
      if (!this.projectForm.policies) {
        this.projectForm.policies = [];
      }
      if (this.projectForm.runInPlatform && this.projectForm.policies.length >= 1) {
        throw "平台策略任务最多支持1个策略";
      }
      if (this.projectForm.policies.length >= 4) {
        throw "最多支持4个策略同时执行";
      }
      this.projectForm.policies.push({
        policySid: "",
        order: 0,
        priority: 0,
      });
      this.retSetOrder();
    },
    removeTimmer(sid: string) {
      let index = -1;
      for (let i = 0; i < this.projectForm.policies.length; i++) {
        if (this.projectForm.policies[i].sid == sid) {
          index = i;
        }
      }
      this.projectForm.policies.splice(index, 1);
      this.retSetOrder();
    },
    retSetOrder() {
      let i = 1;
      this.projectForm.policies.forEach((x: any) => {
        x.order = i;
        i += 1;
      });
    },
    async oneNext(step: number) {
      this.step = step;
    },
    async select() {
      const actionBar: any = this.$refs.action;
      this.searchStr = actionBar.getSearch();
      if (Utils.StringIsNull(this.searchStr)) {
        this.searchStr = null;
      }
      const ret = await DeviceRequestBill.GetTasks(
        this.searchStr,
        this.currentPage,
        this.pageSize
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    currentChange(val: any) {
      this.current = val;
    },
    insert() {
      this.step = 0;
      this.projectForm = {
        sid: null,
        policies: [],
        target: 0,
      };
      this.loopSavedItem = [];
      this.devSavedItem = [];
      this.softSavedItem = [];
      this.jgSavedItem = [];
      this.routerSavedItem = [];
      this.getwaySavedItem = [];
      this.hardSavedItem = [];
      this.projectForm.target = 0;
      this.targetChange(0);
      this.dialogTitle.title = "新增策略任务";
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    closeDialog() {
      const dialog: any = this.$refs.projectDialog;
      dialog.hiden();
    },
    async modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.dialogTitle.title = "修改策略任务";
      const reslut = await DeviceRequestBill.GetTaskDetail(this.current.sid);
      this.projectForm = reslut;

      this.step = 0;
      this.loopSavedItem = reslut.loops;
      this.devSavedItem = reslut.lights;
      this.softSavedItem = reslut.softwareGroups;
      this.jgSavedItem = reslut.jgGateways;
      this.routerSavedItem = reslut.groups;
      this.getwaySavedItem = reslut.gateways;
      this.hardSavedItem = reslut.hardwareGroups;
      this.targetChange(this.current.target == 2 ? 1 : 0);
      const dialog: any = this.$refs.projectDialog;
      dialog.show();
    },
    del() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.currentSid = this.current.sid;
      const dialog: any = this.$refs.del;
      dialog.show();
    },
    ex() {
      //
    },
    inport() {
      //
    },
    search() {
      this.select();
    },
    searchChanged(str: string) {
      this.searchStr = str;
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.select();
    },
    async onSubmit() {
      this.projectForm.groups = this.routerSavedItem;
      this.projectForm.softwareGroups = this.softSavedItem;
      this.projectForm.lights = this.devSavedItem;
      this.projectForm.jGGateways = this.jgSavedItem;
      this.projectForm.gateways = this.getwaySavedItem;
      this.projectForm.loops = this.loopSavedItem;
      this.projectForm.hardwareGroups = this.hardSavedItem;
      if (!this.projectForm.sid) {
        await HttpUtil.XCHttpPost(Urls.AddTask, this.projectForm, true, false);
      } else {
        await HttpUtil.XCHttpPost(Urls.UpdateTask, this.projectForm, true, false);
      }
      this.closeDialog();
      this.select();
    },
  },
});
